<template>
    <f7-sheet
        :opened="syncedOpened"
        v-bind="$attrs"
        backdrop
        :swipe-to-close="swipeToClose"
        :close-by-backdrop-click="closeByBackdropClick"
        :close-by-outside-click="closeByOutsideClick"
        class="base-sheet-popup"
        @sheet:closed="closeModal()"
    >
        <slot v-if="$slots.default"></slot>

        <template v-else>
            <div v-if="$slots.header" class="base-sheet-popup__header">
                <slot name="header"></slot>
            </div>

            <div v-else class="base-sheet-popup__header flex w-full p-4 relative justify-content-center">
                <h1 class="text-2xl">{{ title }}</h1>
                <div
                    class="base-sheet-popup__header__close-popup-btn absolute top-1 cursor-pointer"
                    @click="closeModal()"
                >
                    <span v-if="!disableCross" class="w-10 h-10 text-2xl">&times;</span>
                </div>
            </div>

            <div v-if="$slots.body" class="base-sheet-popup__body">
                <slot name="body"></slot>
            </div>

            <hr v-if="$slots.footer && !disableLines" class="w-4/5 mx-auto" />

            <div v-if="$slots.footer" class="base-sheet-popup__footer">
                <slot name="footer"></slot>
            </div>
        </template>
    </f7-sheet>
</template>

<script>
    const EventsEnum = Object.freeze({
        OPENED_UPDATE: 'opened:update'
    });
    export default {
        model: {
            prop: 'opened',
            event: EventsEnum.OPENED_UPDATE
        },
        props: {
            swipeToClose: {
                type: Boolean,
                default: true
            },
            closeByBackdropClick: {
                type: Boolean,
                default: true
            },
            closeByOutsideClick: {
                type: Boolean,
                default: true
            },
            opened: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            disableLines: {
                type: Boolean,
                default: false
            },
            disableCross: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            syncedOpened: {
                get() {
                    return this.opened;
                },
                set(state) {
                    this.$emit(EventsEnum.OPENED_UPDATE, state)
                }
            }
        },

        methods: {
            closeModal() {
                this.syncedOpened = false;
                this.$emit('close');
                window.dispatchEvent(new Event('resize'));
            }
        }
    }
</script>

<style lang="scss">
.base-sheet-popup {
    height: auto;
    padding: 0 10px 10px 10px;

    &__header {
        &__close-popup-btn {
            // Idk why, but .right is not defined :(
            right: 20px;
        }
    }
}
</style>
